import React from 'react';
import { useSelector } from 'react-redux';
import {
  FooterWrapper,
  FooterContainer,
  CopyFooter,
  Logo,
  FooterSection,
  SectionHeader,
  SectionText,
  Icon,
  CopyText,
  RightCopyContainer,
  Link,
  SectionExtLink,
  A,
  CopyExtLink,
} from './styles';
import { userRoles } from 'util/appConstants';
import { useAppContext } from 'hooks/useContext';
import { getConfig } from 'functions/getConfig';
import * as strings from './strings';
import Path from 'routes/Path';

export default function Footer() {
  const { userRole, isCommunityUser } = useSelector((state) => state.auth);

  const { language } = useAppContext();

  let LINKS = strings.FRONT_LINKS;
  LINKS = isCommunityUser && userRole !== userRoles.CANDIDATE ? [...LINKS, ...strings.LOGGED_IN_LINKS()] : LINKS;
  LINKS =
    userRole && ![userRoles.EMPLOYEE, userRoles.CANDIDATE].includes(userRole)
      ? [...LINKS, ...strings.ADMIN_LINKS()]
      : LINKS;

  return (
    <FooterWrapper>
      <FooterContainer>
        <Link to={Path.landingPage}>
          <Logo />
        </Link>
        <FooterSection>
          <SectionHeader>{strings.QUICK_LINKS[language]}</SectionHeader>
          {LINKS.map((link) => {
            return link.extTo ? (
              <A key={`${link[language].replace(' ', '-').toLowerCase()}-${link.extTo}`} href={link.extTo}>
                {link[language]}
              </A>
            ) : (
              <Link key={`${link[language].replace(' ', '-').toLowerCase()}-${link.to}`} to={link.to}>
                {link[language]}
              </Link>
            );
          })}
        </FooterSection>
        <FooterSection>
          <SectionHeader>{strings.GET_IN_TOUCH[language]}</SectionHeader>
          <SectionText>
            Drottninggatan 38
            <br />
            411 07 {strings.GOTHENBURG[language]}
          </SectionText>
          <SectionExtLink href="tel:+46739602601">+46 739 602 601</SectionExtLink>
          <SectionExtLink href="mailto:contact@futureskill.com">contact@futureskill.com</SectionExtLink>
        </FooterSection>
        <FooterSection isSocial>
          <a href="https://www.facebook.com/futureskillsweden/">
            <Icon icon={'\f09a'} />
          </a>
          <a href="https://www.linkedin.com/company/future-skill/">
            <Icon icon={'\f0e1'} />
          </a>
        </FooterSection>
      </FooterContainer>
      <CopyFooter>
        <CopyText>© 2023 FutureSkill.com. {strings.ALL_RIGHTS[language]}</CopyText>
        <RightCopyContainer>
          <CopyExtLink href={`${getConfig().REACT_URL}/privacy-policy`}>{strings.PRIVACY_POLICY[language]}</CopyExtLink>
          <CopyExtLink href={`${getConfig().REACT_URL}/membership`}>
            {strings.MEMBERSHIP_AGREEMENT[language]}
          </CopyExtLink>
          {/* <CopyText> | </CopyText>
          <CopyLink to="">{TERMS_AND_CONDITIONS[language]}</CopyLink> */}
        </RightCopyContainer>
      </CopyFooter>
    </FooterWrapper>
  );
}
